import useUserProgram from './useUserProgram'

const useIsDomesticUser = () => {
  const program = useUserProgram()
  return program !== 'INTERNATIONAL'
}

export default useIsDomesticUser
